module.exports = __webpack_public_path__ + "assets/pulse_black.eb0a0851.svg";